import { render, staticRenderFns } from "./ExpandText.vue?vue&type=template&id=50930601&"
import script from "./ExpandText.vue?vue&type=script&lang=js&"
export * from "./ExpandText.vue?vue&type=script&lang=js&"
import style0 from "./ExpandText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports